import { render, staticRenderFns } from "./middleForPay.vue?vue&type=template&id=8a9ff812&"
import script from "./middleForPay.vue?vue&type=script&lang=js&"
export * from "./middleForPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports